import { render, staticRenderFns } from "./GP2BrowserAssociationRegionPlot.vue?vue&type=template&id=073a3c97&scoped=true&"
import script from "./GP2BrowserAssociationRegionPlot.vue?vue&type=script&lang=js&"
export * from "./GP2BrowserAssociationRegionPlot.vue?vue&type=script&lang=js&"
import style0 from "./GP2BrowserAssociationRegionPlot.vue?vue&type=style&index=0&id=073a3c97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073a3c97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073a3c97')) {
      api.createRecord('073a3c97', component.options)
    } else {
      api.reload('073a3c97', component.options)
    }
    module.hot.accept("./GP2BrowserAssociationRegionPlot.vue?vue&type=template&id=073a3c97&scoped=true&", function () {
      api.rerender('073a3c97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/gp2Browser/GP2BrowserAssociationRegionPlot.vue"
export default component.exports